import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Map, Typography } from "@otp/ui";
import { MarkerActive } from "@otp/icons";
import { StoreModel } from "src/graphql/generated/graphql";

import styles from "./index.module.css";

const MAP_ACCESS_TOKEN = process.env.REACT_APP_MAP_TOKEN as string;

export const RestaurantMap = ({ store }: { store: Partial<StoreModel> }) => {
  const { t } = useTranslation();

  if (!store) {
    return null;
  }

  const { latitude, longitude } = store;
  const storeMarker = {
    latitude: latitude as number,
    longitude: longitude as number,
    data: store,
  };

  return (
    <div>
      <Typography
        variant="body2"
        fontWeight="bold"
        className="flex items-center"
      >
        <MarkerActive className="mr-2" /> {t("common.location")}
      </Typography>

      <div className={clsx(styles.mapWrapper, "mt-4")}>
        <Map
          markers={[storeMarker]}
          accessToken={MAP_ACCESS_TOKEN}
          defaultCenter={{
            latitude: latitude as number,
            longitude: longitude as number,
          }}
        />
      </div>
    </div>
  );
};
